
import { defineComponent } from 'vue'
import { TYPES } from '../../../../config/inversify.types'

import AuditDetails from '../audit-details.component.vue'

export default defineComponent({
  name: 'ContextualizeServiceAuditDetails',
  components: {
    AuditDetails,
  },
  inject: {
    objectIdService: TYPES.ObjectIdService,
  },
  props: {
    audit: {
      type: Object,
      required: true,
    },
    ignoredFields: {
      type: Array,
      default: () => AuditDetails.props.ignoredFields.default(),
    },
    messages: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const baseClass = 'epb-contextualize-service-audit-details'
    return {
      baseClass,
    }
  },
  methods: {
    getItemText(filters: { name: string; values: string[] }): string {
      const filtersText = Object.entries(filters).map(([key, value]: [string, any]) => {
        return `<strong>${key}:</strong> ${Array.isArray(value) ? value.join(', ') : value}`
      })
      return filtersText.join('<br>')
    },
  },
})
